export type InventoryAnalyticsUtmParams = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
};

const allowedUtms = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content'
];

export default function getInventoryAnalyticsUtmParams(
  utmParams: Record<string, string>
): InventoryAnalyticsUtmParams {
  return allowedUtms.reduce((filteredUtmParams, key) => {
    if (utmParams[key]) {
      filteredUtmParams[key] = utmParams[key];
    }

    return filteredUtmParams;
  }, {});
}
